import React, { useMemo } from "react";
import SliderLib, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { getSelectedDimension, getSettings } from "./Slider.helpers";
import Styles from "./Slider.styles";
import { SliderProps as Props, StrictConfig } from "./Slider.types";
import useWindowSize from "hooks/useWindowSize";
import { getChildren } from "utils/children.utils";

const Slider: React.FC<Props> = props => {
  const { className, width, children, height, responsive = [], gap } = props;
  const { slideWidth, animated, infinite, arrows, parentRef } = props;
  const { prevArrow, nextArrow } = props;
  const { width: windowWidth } = useWindowSize();
  const defaultDimensions = useMemo<StrictConfig>(
    () => ({ height, width: width ?? windowWidth, slideWidth, gap }),
    [width, height, slideWidth, windowWidth, gap]
  );
  const responsiveCandidate = getSelectedDimension(responsive, windowWidth);
  const selectedConfig = responsiveCandidate ?? defaultDimensions;
  const { width: selectedWidth, height: selectedHeight } = selectedConfig;

  const actualChildren = getChildren(children);

  const settingOverrides: Settings = {
    autoplay: !!animated,
    autoplaySpeed: animated,
    infinite: !!infinite,
    arrows: !!arrows,
    prevArrow,
    nextArrow
  };

  const settings = getSettings(settingOverrides);

  return (
    <Styles
      className={`Slider ${className}`}
      slideWidth={slideWidth}
      width={selectedWidth ?? windowWidth}
      height={selectedHeight}
      gap={gap}
      slidesCount={actualChildren.length}
    >
      {/* @ts-ignore */}
      <SliderLib
        {...settings}
        ref={slider => {
          if (parentRef) parentRef.current = slider;
        }}
      >
        {actualChildren.map((slide, index) => {
          return (
            <div className="Slider__slide" key={index}>
              {slide}
            </div>
          );
        })}
      </SliderLib>
    </Styles>
  );
};

export default Slider;
